import Location from './Location';

import AuntyKewaGraphics from './AuntyKewaGraphics';

export default class AuntyKewa extends Location {
    constructor() {
        super('auntyKewa');
        this.Graphics = AuntyKewaGraphics;
    }

}